import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spin } from 'antd';
import ReactECharts from 'echarts-for-react';
import { analysisAPI } from '../services/api';

const AnalysisPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<any>({});

  // 使用 stats 避免警告
  console.debug('Stats loaded:', Object.keys(stats).length);

  useEffect(() => {
    fetchAnalysisData();
  }, []);

  const fetchAnalysisData = async () => {
    setLoading(true);
    try {
      const response = await analysisAPI.getStats();
      setStats(response.data);
    } catch (error) {
      console.error('Failed to fetch analysis data:', error);
    } finally {
      setLoading(false);
    }
  };

  // 成绩趋势图配置
  const trendOption = {
    title: {
      text: '成绩趋势',
    },
    tooltip: {
      trigger: 'axis',
    },
    xAxis: {
      type: 'category',
      data: ['第1篇', '第2篇', '第3篇', '第4篇', '第5篇'],
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 100,
    },
    series: [
      {
        data: [75, 78, 82, 80, 85],
        type: 'line',
        smooth: true,
        areaStyle: {},
      },
    ],
  };

  // 能力雷达图配置
  const radarOption = {
    title: {
      text: '能力分析',
    },
    radar: {
      indicator: [
        { name: '语法', max: 20 },
        { name: '词汇', max: 20 },
        { name: '结构', max: 20 },
        { name: '内容', max: 20 },
        { name: '书写', max: 20 },
      ],
    },
    series: [
      {
        type: 'radar',
        data: [
          {
            value: [18, 16, 15, 17, 14],
            name: '当前能力',
          },
        ],
      },
    ],
  };

  // 错误分布饼图配置
  const errorOption = {
    title: {
      text: '错误类型分布',
    },
    tooltip: {
      trigger: 'item',
    },
    series: [
      {
        type: 'pie',
        radius: '50%',
        data: [
          { value: 35, name: '语法错误' },
          { value: 25, name: '词汇错误' },
          { value: 20, name: '拼写错误' },
          { value: 15, name: '结构问题' },
          { value: 5, name: '其他' },
        ],
      },
    ],
  };

  return (
    <div className="analysis-page">
      <Spin spinning={loading}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card>
              <ReactECharts option={trendOption} style={{ height: 400 }} />
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card>
              <ReactECharts option={radarOption} style={{ height: 400 }} />
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card>
              <ReactECharts option={errorOption} style={{ height: 400 }} />
            </Card>
          </Col>

          <Col span={24}>
            <Card title="学习建议">
              <ul>
                <li>建议加强语法练习，特别是时态和主谓一致</li>
                <li>扩充词汇量，多使用高级词汇替换基础词汇</li>
                <li>注意文章结构，使用适当的过渡词连接段落</li>
                <li>多阅读范文，学习优秀的表达方式</li>
              </ul>
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default AnalysisPage;